import DetailedBalanceLeveling from './components/DetailedBalanceLeveling/DetailedBalanceLeveling'
import { AllRules } from './components/AllRules'
import { AllAutoTopUpRules } from './components/AutoTopUpRules'
import { useState } from 'react'
import { Tabs, Tab, Paper, Box } from '@mui/material'

const BalanceLeveling = () => {
  const [selectedTab, setSelectedTab] = useState(0)

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  return (
    <>
      {/* Top transactions table */}
      <DetailedBalanceLeveling />

      {/* Tabs container */}
      <Paper elevation={2} sx={{ margin: '8px 4px', overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Balance Leveling rule" />
            <Tab label="Auto Top Up rule" />
          </Tabs>
        </Box>

        {/* Tab content */}
        <Box sx={{ padding: '8px' }}>
          {selectedTab === 0 && <AllRules />}
          {selectedTab === 1 && <AllAutoTopUpRules />}
        </Box>
      </Paper>
    </>
  )
}

export default BalanceLeveling
